import { render, staticRenderFns } from "./UsersPage.vue?vue&type=template&id=191405a1&scoped=true"
import script from "./UsersPage.vue?vue&type=script&lang=js"
export * from "./UsersPage.vue?vue&type=script&lang=js"
import style0 from "./UsersPage.vue?vue&type=style&index=0&id=191405a1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191405a1",
  null
  
)

export default component.exports